import type { ListFeedbackResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { ListFeedbacksGateway } from './list-feedbacks.gateway';

/**
 * Real implementation over the shared api client: the single place that knows
 * the list-feedback endpoints. `api.get/patch` unwrap the `{ success, data }`
 * envelope.
 */
export const httpListFeedbacksGateway: ListFeedbacksGateway = {
  loadFeedbacks: () => api.get<ListFeedbackResponse[]>('/admin/list-feedbacks'),

  loadOpenCount: async () =>
    (await api.get<{ count: number }>('/admin/list-feedbacks/open-count')).count,

  updateStatus: (id, status) =>
    api.patch<ListFeedbackResponse>(`/admin/list-feedbacks/${id}/status`, { status }),
};
